<dx-popup
    #manageContractPopup
    width="70%"
    height="75%"
    minWidth="35%"
    minHeight="50%"
    title="Contract For: {{ popupTitle }}"
    [showTitle]="true"
    [resizeEnabled]="true"
    [showCloseButton]="true"
    [dragEnabled]="true"
    [closeOnOutsideClick]="false"
    [visible]="visible"
    (onShown)="onShown()"
    (onHidden)="onHidden()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item baseSize="auto">
                <div *dxTemplate class="toolbar-container">
                    <dx-toolbar>
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <h2 class="header-container">
                                    Contracts
                                    <sup class="page-help-link">
                                        <a [href]="helpLink" target="_blank" [ngClass]="iconHelp"></a>
                                    </sup>
                                </h2>
                            </div>
                        </dxi-item>
                        <dxi-item location="after" [visible]="workflowId && isInteralUser">
                            <div *dxTemplate>
                                <dx-button
                                    type="success"
                                    hint="Save Workflow Vendor Contracts"
                                    template="buttonTemplate"
                                    (onClick)="onSaveWFVendorContractClick()"
                                >
                                    <div *dxTemplate="let btn of 'buttonTemplate'">
                                        <i class="add-padding" [ngClass]="iconSave"></i>
                                        Save Workflow Vendor Contracts
                                        <app-security-info
                                            iconColor="cc-white-icon"
                                            securityIndicator="LOCK"
                                            apiAction="POST"
                                            apiUrl="api/wfe/vendor/contracts"
                                        ></app-security-info>
                                    </div>
                                </dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after" [visible]="allowAddVendorContract && isInteralUser">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    hint="Add New Contract"
                                    template="buttonTemplate"
                                    (onClick)="onAddNewContractClick()"
                                >
                                    <div *dxTemplate="let btn of 'buttonTemplate'">
                                        <i class="add-padding" [ngClass]="iconAdd"></i>
                                        Add New Contract
                                        <app-security-info
                                            iconColor="cc-white-icon"
                                            securityIndicator="LOCK"
                                            apiAction="POST"
                                            apiUrl="api/va/contract"
                                        ></app-security-info>
                                    </div>
                                </dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
            <dxi-item [ratio]="1">
                <div *dxTemplate class="grid-container">
                    <cc-data-grid-features
                        [stateConfig]="{ storageKey: 'MP_CC_VM_MANAGE_CONTRACT_GRID' }"
                        [gridFeatures]="{ stylingMode: menu }"
                        [dataSource]="manageContracteData"
                    >
                        <dx-data-grid
                            #contractGrid
                            appHasInternalUserColumns
                            width="100%"
                            height="100%"
                            keyExpr="vendorContractId"
                            class="cc-vertical-center-cell-data-grid"
                            [dataSource]="manageContracteData"
                            (onContentReady)="onContentReady()"
                            (onSelectionChanged)="onGridSelection($event)"
                        >
                            <ng-container *ngIf="!!workflowId">
                                <dxo-selection showCheckBoxesMode="always" mode="multiple"></dxo-selection>
                            </ng-container>
                            <ng-container *ngIf="!workflowId">
                                <dxi-column
                                    [visible]="allowActions"
                                    name="InternalActions"
                                    caption="Action"
                                    alignment="center"
                                    [showInColumnChooser]="false"
                                    [allowGrouping]="false"
                                    cellTemplate="actionCellTemplate"
                                    headerCellTemplate="actionHeaderCellTemplate"
                                >
                                    <div *dxTemplate="let row of 'actionCellTemplate'">
                                        <app-grid-actions-menu
                                            [actionMenuItems]="actionMenuItems"
                                            [record]="row.data"
                                            [rowIndex]="row.rowIndex"
                                            (onActionClick)="onActionClick($event)"
                                        ></app-grid-actions-menu>
                                    </div>
                                </dxi-column>
                            </ng-container>

                            <dxi-column dataField="contractType" dataType="string" caption="Contract Type"></dxi-column>
                            <dxi-column dataField="contractTerm" dataType="string" caption="Contract Term"></dxi-column>
                            <dxi-column
                                dataField="autoRenewDisplayText"
                                dataType="string"
                                caption="Auto Renew"
                            ></dxi-column>
                            <dxi-column
                                dataField="effectiveDate"
                                dataType="date"
                                caption="Effective Date"
                                [width]="100"
                                [format]="dateFormat"
                            ></dxi-column>
                            <dxi-column
                                dataField="endDate"
                                dataType="date"
                                caption="End Date"
                                [width]="100"
                                [format]="dateFormat"
                            ></dxi-column>
                            <dxi-column
                                dataField="status"
                                dataType="string"
                                caption="Status"
                                [width]="80"
                                alignment="center"
                                cellTemplate="booleanCellTemplate"
                            ></dxi-column>
                            <dxi-column
                                dataField="description"
                                dataType="string"
                                caption="Description"
                                cellTemplate="descriptionTemplate"
                            ></dxi-column>
                            <dxi-column
                                caption=""
                                alignment="center"
                                [width]="80"
                                [allowGrouping]="false"
                                cellTemplate="documentCellTemplate"
                            ></dxi-column>
                            <ng-container>
                                <dxi-column
                                    caption="History"
                                    alignment="center"
                                    [allowGrouping]="false"
                                    cellTemplate="historyCellTemplate"
                                ></dxi-column>
                            </ng-container>

                            <dxi-column
                                dataField="serviceCategory"
                                dataType="string"
                                caption="Service Category"
                                [visible]="false"
                            ></dxi-column>
                            <dxi-column
                                dataField="serviceFrequency"
                                dataType="string"
                                caption="Service Frequency"
                                [visible]="false"
                            ></dxi-column>

                            <div *dxTemplate="let row of 'documentCellTemplate'">
                                <div *ngIf="!!row.data.documentIds && row.data.documentIds.length === 1">
                                    <i
                                        class="cc-1-5x cc-hyperlink cc-icon-pdf"
                                        [ngClass]="iconPdf"
                                        (click)="onDocumentClick(row.data)"
                                    ></i>
                                </div>
                                <div *ngIf="!!row.data.documentIds && row.data.documentIds.length > 1">
                                    <i
                                        class="cc-1-5x dx-theme-accent-as-text-color cc-hyperlink"
                                        [ngClass]="iconFolder"
                                        (click)="onDocumentFolderClick(row.data)"
                                    ></i>
                                </div>
                            </div>

                            <div *dxTemplate="let row of 'booleanCellTemplate'">
                                <ng-container *ngIf="row.value === 'Active'">
                                    <i class="cc-check-icon cc-1-5x" [ngClass]="iconCheck"></i>
                                </ng-container>
                                <ng-container *ngIf="row.value === 'Expired'">
                                    <i class="cc-cross-icon cc-1-5x" [ngClass]="iconCross"></i>
                                </ng-container>
                                <ng-container *ngIf="row.value === 'Future'">
                                    <i class="cc-icon-orange cc-1-5x" [ngClass]="iconCheck"></i>
                                </ng-container>
                            </div>

                            <div *dxTemplate="let data of 'descriptionTemplate'" class="description-text">
                                <app-hyperlink-creator
                                    mode="hyperlinkOnly"
                                    [displayText]="data.value"
                                    (onLinkClick)="toggleDescription(data)"
                                ></app-hyperlink-creator>
                                <div
                                    *ngIf="data.rowIndex === gridRowIndex && showDescription"
                                    class="description-long-text"
                                >
                                    {{ data.value }}
                                </div>
                            </div>

                            <div *dxTemplate="let row of 'historyCellTemplate'">
                                <div class="cc-hyperlink">
                                    <i
                                        class="cc-1-5x dx-theme-accent-as-text-color"
                                        title="History"
                                        [ngClass]="iconHistory"
                                        (click)="onHistoryClick(row.data)"
                                    ></i>
                                </div>
                            </div>

                            <div *dxTemplate="let header of 'actionHeaderCellTemplate'">
                                {{ header.column.caption }}
                                <app-security-info
                                    securityIndicator="LOCK"
                                    apiAction="POST"
                                    apiUrl="api/va/contract"
                                ></app-security-info>
                            </div>
                        </dx-data-grid>
                    </cc-data-grid-features>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate class="button-container">
                    <dx-toolbar>
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Close"
                                    hint="Close"
                                    [icon]="iconClose"
                                    (onClick)="onHidden()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<app-manage-contract-document
    *ngIf="showContractDocument"
    [communityId]="communityId"
    [communityVendorId]="communityVendorId"
    [vendorCode]="vendorCode"
    [popupTitle]="documentTitle"
    [vendorContractId]="selectedContract?.vendorContractId"
    (onClose)="showContractDocument = false"
></app-manage-contract-document>

<app-community-vendor-history
    *ngIf="showHistory"
    [logId]="selectedContract?.vendorContractId"
    [communityId]="communityId"
    [historySource]="contractHistoryData"
    [historyColumns]="contractHistoryColumns"
    (onClose)="showHistory = false"
></app-community-vendor-history>

<app-contract-editor
    *ngIf="showContractEditor"
    [vendorName]="vendorName"
    [communityId]="communityId"
    [communityVendorId]="communityVendorId"
    [vendorCode]="vendorCode"
    [vendorContractId]="selectedContract?.vendorContractId"
    (onClose)="onContractEditorClose($event)"
></app-contract-editor>

<dx-load-panel *ngIf="loadingVisible" [position]="{ of: 'body' }" [visible]="loadingVisible"></dx-load-panel>
